import { SVG, SVGProps } from './svg'

export function IconSwitchHorizontal(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="m17.9 13.4 3-3c.2-.2.2-.6 0-.8l-3-3a.5.5 0 0 0-.9.4v2H9.5c-.3 0-.5.2-.5.5v1c0 .3.2.5.5.5H17v2a.5.5 0 0 0 .9.4ZM7 13h7.5c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5H7v2a.5.5 0 0 1-.9.4l-3-3a.5.5 0 0 1 0-.8l3-3a.5.5 0 0 1 .9.4v2Z" />
    </SVG>
  )
}
